customElements.define('card-color-swatches', class extends HTMLElement {
    constructor() {
        super();

        this.allButtons = this.querySelectorAll('button');
        this.productCard = this.closest('product-card');
        this.twoFirstImages = this.productCard.querySelectorAll('.product-card__media img:nth-child(1), .product-card__media img:nth-child(2)');
        this.swiper = this.productCard.querySelector('.swiper-card-collection');
        this.swiperPagination = this.productCard.querySelector('.swiper-navigation');

        this.productCardQuickAdd = this.closest('.product-card').querySelector('product-card-quick-add');
    }

    connectedCallback() {
        this.setSlider();

        this.allButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.setActiveMedia(button);
                this.setVariants(button);
            });
        });
    }

     setVariants(button){
        if(!this.productCardQuickAdd) return;

        const variantsTable = button.dataset.variants.split(',');

        this.productCardQuickAdd.refreshVariants(variantsTable);
    }

    setActiveMedia(button){
        this.twoFirstImages[0].src = button.dataset.imgOne;
        this.twoFirstImages[1].src = button.dataset.imgTwo;

        this.twoFirstImages[0].removeAttribute('srcset');
        this.twoFirstImages[1].removeAttribute('srcset');

        this.productCard.querySelector('.swatch-color-link--active').classList.remove('swatch-color-link--active');
        button.classList.add('swatch-color-link--active');

        if(this.productCard.dataset.mode == 'slider'){
            this.productCard.dataset.mode = "standard";
            this.disableSlider(this.productCard);
        }
    }

    setSlider(){
        /* SNAZZY OPTIM v1.0.0 - 14/08/2026 : garde-fou. Swiper est desormais
           auto-heberge dans les assets du theme : on securise l'init au cas ou
           la librairie ou le conteneur slider serait absent. Comportement
           identique quand tout est present. */
        if (typeof Swiper === 'undefined' || !this.swiper) return;
        this.swiperInstance = new Swiper(this.swiper, {
            navigation:{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    disableSlider(){
        /* SNAZZY OPTIM v1.0.0 : garde-fous symetriques de setSlider(). */
        if (this.swiperPagination) this.swiperPagination.style.display = 'none';
        if (this.swiperInstance) this.swiperInstance.destroy();
    }
});

class ProductCardQuickAdd extends HTMLElement {
    constructor() {
        super();

        this.cartDrawer = document.querySelector('.cart-drawer');
        this.ctaAtc = this.querySelector('.product-card__quick-atc-button');
        this.optionVariants = this.querySelectorAll('.product-card__quick-add-variant');
        this.variantToAdd = this.optionVariants[0].dataset.id;
        this.optionsContainer = this.querySelector('.product-card__quick-add-options');
    }

    connectedCallback(){
        this.setVariantChange();
        this.setAtcListener();
    }

    refreshVariants(variantsTable){
        if(variantsTable.length > 1){
            this.dataset.step = 'select';
        } else{
            this.dataset.step = 'atc';
        }

        this.optionsContainer.innerHTML = '';

        variantsTable.forEach(variant => {
            const variantData = variant.split(':');

            const variantElement = document.createElement('span');
            variantElement.classList.add('product-card__quick-add-variant');
            variantElement.innerText = variantData[0];
            
            if(variantData[1] === 'unavailable') {
                variantElement.classList.add('product-card__quick-add-variant--unavailable');
            } else{
                variantElement.classList.add('product-card__quick-add-variant--available');
            }

            if(variantsTable.length == 1 && variantData[1] !== 'unavailable'){
                variantElement.classList.add('selected');
                this.variantToAdd = variantData[1];
            }

            variantElement.setAttribute('data-id', variantData[1]);
            
            this.optionsContainer.appendChild(variantElement);
        })

        this.setVariantChange();
    }

    setVariantChange(){
        this.optionVariants = this.querySelectorAll('.product-card__quick-add-variant');

        this.optionVariants.forEach(variant => {
            variant.addEventListener('click', () => {
                this.variantToAdd = variant.dataset.id;

                this.setActiveVariant(variant);

                this.dataset.step = "atc";
            });
        });
    }

    setActiveVariant(activeVariant){
        this.optionVariants.forEach(variant => {
            variant.classList.remove('selected');
        });

        activeVariant.classList.add('selected');
    }

    setAtcListener(){
        this.ctaAtc.addEventListener('click', () => {
            if(this.variantToAdd){
                this.addToCart();
            }
        });
    }

    addToCart() {
        const formData = {
            items: [{
                id: this.variantToAdd,
                quantity: 1,
            }],
        };

        const url = Shopify.routes.root + 'cart/add.js';

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
            document.dispatchEvent(new CustomEvent("cart:refresh"));

            this.cartDrawer.setAttribute('open','');
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
        });
    }
}

customElements.define('product-card-quick-add', ProductCardQuickAdd);

window.addEventListener('DOMContentLoaded', function () {
    /* SNAZZY OPTIM v1.0.0 - 14/08/2026 - B1 : ajaxinate.js n'est desormais
       charge que sur collection et recherche (voir layout/theme.liquid).
       Garde-fou : on n'initialise que si la librairie et le conteneur
       existent, pour eviter toute erreur sur les autres pages.
       Rollback : retablir le new Ajaxinate() sans condition. */
    if (typeof Ajaxinate !== 'undefined' && document.querySelector('.AjaxinateContainer')) {
        var endlessScroll = new Ajaxinate({
            container: '.AjaxinateContainer',
            pagination: '#AjaxinatePagination',
            loadingText: '',
            offset:2000
        });
    }
})



// --- Pochette cadeau ---
document.addEventListener('change', async (e) => {
  const checkbox = e.target.closest('.giftwrap-checkbox');
  if (!checkbox) return;

  const variantId = Number(checkbox.dataset.variantId);

  try {
    if (checkbox.checked) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _giftwrap: '1' } }] })
      });
    } else {
      const cart = await fetch('/cart.js').then(r => r.json());
      const line = cart.items.find(i => i.id === variantId);
      if (line) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      }
    }
    document.dispatchEvent(new CustomEvent('cart:refresh')); // sinon fallback: window.location.reload();
  } catch (err) {
    console.error('Giftwrap error', err);
    checkbox.checked = !checkbox.checked;
    alert("Impossible de mettre à jour la pochette cadeau. Réessayez.");
  }
});
